module.exports = __webpack_public_path__ + "media/application/images/partners/crif-d4473f72e99b834c3e155e0b556f07fd922c54f8b9e35e31d8cfb3d19033cd6c.png";